import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export var NumberNotification = function NumberNotification(_ref) {
  var className = _ref.className,
    number = _ref.number;
  var isLimitSize = number >= 99;
  return /*#__PURE__*/_jsx("span", {
    className: clsx('tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-select-none tw-h-2 tw-w-2 tw-rounded-full tw-bg-alert-500 tw-font-label1 tw-text-neutral-light-100 tw-p-1.2', className, {
      'tw-font-caption !tw-text-[0.9rem]': isLimitSize
    }),
    children: isLimitSize ? '+99' : number
  });
};